(function($){
	
	const
	header = $('.site-header'),
	site_container = $('.content');
	
	let admin_offset = ($('body').hasClass('admin-bar')) ? 'site-header--is-admin': '';
	
	header.addClass(admin_offset);
	
	function set_header_offset() {
		let
		header_height = header[0].clientHeight,
		header_height_rem = header_height / 16;
		
		site_container.css('margin-top', header_height_rem + 'rem');
	}
	
	set_header_offset();
	$(window).resize( set_header_offset );
	
	gsap.registerPlugin(ScrollTrigger);
	sticky_init();
	
	function sticky_init() {
		ScrollTrigger.create({
			trigger: '.site-header',
			start: 'bottom top',
			end: 'bottom+=999999',
			toggleClass: {
				targets: '.site-header__logo',
				className: 'site-header__logo--small',
			},
		});
	}
	
})(jQuery);